/* eslint-disable no-undef */
import {
  PDT_FUNNELTYPES,
  PDT_PAGENAMES,
  PDT_PAGEVERSIONS,
} from '../../../common/constants/pdtConstant';
import { checkRVSSection } from '../../../common/src/utils/utils';
import OmnitureUtils from '../../../common/utils/Omniture/OmnitureUtils';
import { CUSTOM_SECTIONS, VALID_SECTION_CODES } from '../../constants/sectionConstants';
import { getAllUrlParams, getReqDataSsr } from '../../helpers/utils';
import {
  SET_LISTING_SECTIONS,
  SET_LISTING_SECTIONS_IS_LOADING,
  SET_SECTIONS_LOADING,
} from '../constants/sectionsConstants';
import { getListingSections, getUserPackages } from '../services/sectionsService';

export const getListingSectionsAction = requestParam => async (dispatch, getState) => {
  dispatch({
    type: SET_LISTING_SECTIONS_IS_LOADING,
    payload: true,
  });
  const urlParams = ssr.isOnClient ? getAllUrlParams() : getReqDataSsr(requestParam);
  const { fromCityCode, dest, depCity = 'New Delhi', packageIds } = urlParams;
  const { sections, groupMetadata } = getState();

  const params = {
    departureCity: depCity,
    tagDestination: dest,
    page: 'LISTING',
  };

  if (packageIds) {
    params.packageIds = packageIds.split(',');
  }

  if (fromCityCode) {
    params.departureLocusCode = fromCityCode;
  }
  if (ssr?.isOnClient && s?.eVar79) {
    params.experimentKey = s.eVar79;
  }
  params.pageInfo = {
    pageName: PDT_PAGENAMES.DETAILS,
    version: PDT_PAGEVERSIONS.V3,
    funnelType: PDT_FUNNELTYPES.HOLIDAYS,
  };
  const response = await getListingSections(params);

  if (response?.data?.success) {
    const orderWiseSectionsMap = sections?.sectionsByOrder || {};

    response?.data?.sections?.forEach(section => {
      const validSections = Object.values(VALID_SECTION_CODES);
      if (!groupMetadata?.groupDetailsList?.length) {
        validSections?.push(CUSTOM_SECTIONS.ADDS);
      }
      if (validSections.includes(section.sectionCode)) {
        if (!orderWiseSectionsMap[section.order]) {
          orderWiseSectionsMap[section.order] = [];
        }
        orderWiseSectionsMap[section.order].push(section);
      }
    });
    dispatch({
      type: SET_LISTING_SECTIONS_IS_LOADING,
      payload: false,
    });
    dispatch({
      type: SET_LISTING_SECTIONS,
      payload: orderWiseSectionsMap || {},
    });
    if (ssr.MMT_HLD.fromSEO) {
      dispatch({
        type: SET_SECTIONS_LOADING,
        payload: false,
      });
    }
  }
};
export const getUserPackagesAction = () => async (dispatch, getState) => {
  dispatch({
    type: SET_SECTIONS_LOADING,
    payload: true,
  });
  const urlParams = getAllUrlParams();
  const { fromCityCode, dest, depCity = 'New Delhi', packageIds } = urlParams;
  const { sections } = getState();
  let checkForPDO = false;
  const orderWiseSectionsMap = sections?.sectionsByOrder || {};
  const params = {
    departureCity: depCity,
    tagDestinations: [dest],
    page: 'LISTING',
  };

  if (packageIds) {
    params.packageIds = packageIds.split(',');
  }

  if (fromCityCode) {
    params.departureLocusCode = fromCityCode;
  }

  if (urlParams.campaign) {
    params.campaign = urlParams.campaign;
  }
  if (s?.eVar79) {
    params.experimentKey = s?.eVar79;
  }

  params.sectionTypes = [];
  const showNewRVS = checkRVSSection(urlParams);
  Object.values(orderWiseSectionsMap).map(sectionsData => {
    if (sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.PDO && showNewRVS) {
      checkForPDO = true;
      params.sectionTypes.push('PDO');
    }
    // if (sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.PDO) {
    //   OmnitureUtils.trackLoadEvent({
    //     prop54: `RENDERED_SECTION_PDO`,
    //   });
    // }  if(sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.RECENTLY_VIEWED){
    //   OmnitureUtils.trackLoadEvent({
    //     prop54: `RENDERED_SECTION_RVS`,
    //   });
    // }
  });

  const response = await getUserPackages(params);

  if (response?.data?.success) {
    let dataUpdated = false;
    let recentlyViewedPackages = response?.data?.userPackageMetas || {};
    if (checkForPDO) {
      recentlyViewedPackages = response?.data?.sections?.[0]?.cards || {};
      if (
        response?.data?.sections?.[0]?.sectionCode === VALID_SECTION_CODES.PDO &&
        recentlyViewedPackages?.length > 0
      ) {
        OmnitureUtils.trackLoadEvent({
          prop54: 'RENDERED_SECTION_PDO',
        });
      }
    }
    if (
      !checkForPDO &&
      response?.data?.userPackageMetas?.length > 0 &&
      recentlyViewedPackages?.length > 0
    ) {
      OmnitureUtils.trackLoadEvent({
        prop54: 'RENDERED_SECTION_RVS',
      });
    }

    // callPDTApi(checkForPDO ? 'RENDERED_SECTION_PDO' : 'RENDERED_SECTION_RVS');
    Object.values(orderWiseSectionsMap).map(sectionsData => {
      if (sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.RECENTLY_VIEWED) {
        if (recentlyViewedPackages?.length) {
          dataUpdated = true;
          const recentlyViewedSection = {
            cards: recentlyViewedPackages,
            sectionCode: sectionsData?.[0]?.sectionCode,
            type: sectionsData?.[0]?.type,
            order: sectionsData?.[0]?.order,
          };
          orderWiseSectionsMap[sectionsData?.[0]?.order] = [recentlyViewedSection];
        } else {
          delete orderWiseSectionsMap[sectionsData?.[0]?.order];
        }
      }
      if (
        sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.PDO &&
        response?.data?.sections?.[0]?.sectionCode === VALID_SECTION_CODES.PDO &&
        showNewRVS
      ) {
        if (recentlyViewedPackages?.length) {
          dataUpdated = true;
          const pdoSection = {
            cards: recentlyViewedPackages,
            sectionCode: sectionsData?.[0]?.sectionCode,
            type: sectionsData?.[0]?.type,
            order: sectionsData?.[0]?.order,
            id: sectionsData?.[0]?.id,
            header: sectionsData?.[0]?.header,
          };
          orderWiseSectionsMap[sectionsData?.[0]?.order] = [pdoSection];
        } else {
          delete orderWiseSectionsMap[sectionsData?.[0]?.order];
        }
      }
      if (
        sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.PDO ||
        sectionsData?.[0]?.sectionCode === VALID_SECTION_CODES.RECENTLY_VIEWED
      ) {
        if (!dataUpdated) {
          const blankData = {
            cards: [],
            sectionCode: sectionsData?.[0]?.sectionCode,
            type: sectionsData?.[0]?.type,
            order: sectionsData?.[0]?.order,
            id: sectionsData?.[0]?.id,
            header: sectionsData?.[0]?.header,
          };
          orderWiseSectionsMap[sectionsData?.[0]?.order] = [blankData];
        }
        dispatch({
          type: SET_LISTING_SECTIONS,
          payload: orderWiseSectionsMap,
        });
      }
    });
  }
  dispatch({
    type: SET_SECTIONS_LOADING,
    payload: false,
  });
};
